import {useEffect, useState} from "react";
import {UseMutation} from "@reduxjs/toolkit/dist/query/react/buildHooks";
import {BaseQueryApi, FetchBaseQueryError, FetchBaseQueryMeta, MutationDefinition} from "@reduxjs/toolkit/query";
import {QueryReturnValue} from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import {TableMetaType} from "../components/ExtendedTable";

type HookType = UseMutation<MutationDefinition<
    any,
    (
        args: any,
        api: BaseQueryApi,
        extraOptions: {},
    ) => Promise<QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>>, any, any, "api">>

export const useFetchByPagination = <K>(hook: HookType): [K[]] => {
    const [isLoading, setIsLoading] = useState(false)
    const [get] = hook();
    const [meta, setMeta] = useState<TableMetaType | { page_count: number }>({page_count: 1});
    const [page, setPage] = useState(0);
    const [items, setItems] = useState<K[]>([]);

    const reset = () => {
        setMeta({page_count: 1})
        setPage(0)
        setItems([])
    };

    const fetchData = async (params= {}) => {
        setIsLoading(true)

        const res = await get({page: page + 1, ...params});
        if ('error' in res) return
        const meta = res.data._meta;
        if (!meta) return;

        setMeta(meta);

        setPage((prevState) => prevState + 1);
        const key = Object.keys(res.data)[0];
        setItems([...items, ...res.data[key] ?? []]);

        setIsLoading(false)
    };

    const handleFetch = async (params= {}) => {
        if (!isLoading && meta.page_count !== page) {
            fetchData(params)
        }
    };

    useEffect(() => {
        handleFetch()
    }, [isLoading]);

    return [items];
};
